const secrets = {
    sentryDSN: 'https://00000000000000000000000000000000@sentry.io/111111',
    mapillary4: 'MLY|1111111111111111|aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    google: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
    mapyCz: 'eyXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
};

export default secrets;
